// گزارش کلی واگذاری کالا به اماکن
import React, { useState, useEffect } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { ExcelButton } from '../../components/excel';
import WarningDialog from '../../components/WarningDialog';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import { useFormButtons } from '../../utils/vbPerms';
import { API, qs, toFa, Grid, Box, Field, MessageBox, Modal, splitLines, runReport, smallBtn } from './placeShared';

const MODES = [['', '—'], ['row', 'سطر گزارش'], ['1', 'سرگروه'], ['2', 'جمع جاری']];
const TEXT_COLS = ['کد مکان', 'مکان', 'عنوان مکان', 'کد کالا', 'کالا', 'عنوان کالا', 'تاریخ واگذاری', 'نوع کالا'];

function OptionsDialog({ dim, list, onChange, onClose }) {
  const [q, setQ] = useState('');
  const shown = list.filter(o => !q || String(o.title).includes(q) || String(o.code).includes(q));
  const setAll = (v) => onChange(list.map(o => (shown.includes(o) ? { ...o, on: v } : o)));
  const reverse = () => onChange(list.map(o => (shown.includes(o) ? { ...o, on: !o.on } : o)));
  const count = list.filter(o => o.on).length;
  return (
    <Modal title={dim.label} onClose={onClose} width="520px"
      footer={<>
        <button onClick={() => setAll(true)} style={ui.btnCancel}>+</button>
        <button onClick={() => setAll(false)} style={ui.btnCancel}>-</button>
        <button onClick={reverse} style={ui.btnCancel}>*</button>
        <button onClick={onClose} style={ui.btnSave}>انتخاب شده {toFa(count)} از {toFa(list.length)}</button>
      </>}>
      <input value={q} onChange={e => setQ(e.target.value)} placeholder="جستجو" style={{ ...ui.input, marginBottom: '8px' }} />
      {shown.map(o => (
        <label key={String(o.id)} style={{ display: 'flex', gap: '8px', padding: '3px 0', fontSize: '12px' }}>
          <input type="checkbox" checked={o.on} onChange={() => onChange(list.map(x => (x === o ? { ...x, on: !x.on } : x)))} />
          <span style={{ color: '#888', minWidth: '60px' }}>{toFa(o.code)}</span><span>{toFa(o.title)}</span>
        </label>
      ))}
    </Modal>
  );
}

export default function PropertyPlaceAllReport({ user, onBack }) {
  const fb = useFormButtons('FRMPLACE', ['BTNPROPERTYPLACEALLREPORT']);
  const allowed = fb.open && fb.can('BTNPROPERTYPLACEALLREPORT');
  const [meta, setMeta] = useState(null);
  const [range, setRange] = useState({ from: '', to: '' });
  const [report, setReport] = useState(0);
  const [modes, setModes] = useState({});
  const [opts, setOpts] = useState({});
  const [openDim, setOpenDim] = useState(null);
  const [res, setRes] = useState(null);
  const [saved, setSaved] = useState(null);
  const [cur, setCur] = useState({ id: 0, title: '', remark: '' });
  const [msg, setMsg] = useState(null);
  const [ask, setAsk] = useState(null);
  const [loading, setLoading] = useState(false);
  const showMsg = m => setMsg(splitLines(m));

  useEffect(() => {
    if (!allowed) return;
    API('/all-report/meta/').then(j => {
      if (!j.ok) { showMsg(j.msg); return; }
      setMeta(j); setRange({ from: j.from_date, to: j.to_date });
    });
  }, [allowed]);

  const loadOpts = async (key) => {
    if (opts[key]) return opts[key];
    const j = await API(`/all-report/meta/?${qs({ dim: key })}`);
    if (!j.ok) { showMsg(j.msg); return null; }
    const list = j.data.map(o => ({ ...o, on: true }));
    setOpts(o => ({ ...o, [key]: list }));
    return list;
  };
  const openOptions = async (d) => {
    const list = await loadOpts(d.key);
    if (!list) return;
    if (!list.length) { showMsg('هیچ عنوانی تعریف نشده است.'); return; }
    setOpenDim(d);
  };
  const closeOptions = () => {
    const list = opts[openDim.key] || [];
    if (list.length && !list.some(o => o.on)) { showMsg(`حداقل یکی از ${openDim.label} ها باید انتخاب شود`); return; }
    setOpenDim(null);
  };

  const state = () => {
    const dims = {};
    (meta ? meta.dims : []).forEach(d => {
      const e = { mode: modes[d.key] || '' };
      const list = opts[d.key];
      if (list && list.some(o => !o.on)) {
        const on = list.filter(o => o.on).map(o => o.id);
        const off = list.filter(o => !o.on).map(o => o.id);
        if (on.length <= off.length) e.inc = on; else e.exc = off;
      }
      dims[d.key] = e;
    });
    return { report, from: range.from, to: range.to, title: cur.title, dims };
  };

  const run = async () => {
    setLoading(true);
    const j = await API('/all-report/run/', { method: 'POST', body: JSON.stringify(state()) });
    setLoading(false);
    if (!j.ok) { showMsg(j.msg); return; }
    setRes(j);
  };
  const print = () => {
    const key = report === 1 ? 'tadarokat.property_place_all_report_pivot' : 'tadarokat.property_place_all_report';
    runReport(key, { state: JSON.stringify(state()) }, showMsg);
  };

  const openSaved = async () => {
    const j = await API('/all-report/saved/');
    if (!j.ok) { showMsg(j.msg); return; }
    setSaved(j.data);
  };
  const loadSaved = async (r) => {
    setSaved(null);
    const j = await API(`/all-report/saved/${r.id}/`);
    if (!j.ok) { showMsg(j.msg); return; }
    setCur({ id: r.id, title: j.title, remark: j.remark });
    setReport(j.report);
    const m = {};
    const nextOpts = { ...opts };
    for (const key of Object.keys(j.dims)) {
      m[key] = j.dims[key].mode;
      const exc = j.dims[key].exc || [];
      let list = nextOpts[key];
      if (!list && exc.length) {
        const o = await API(`/all-report/meta/?${qs({ dim: key })}`);
        list = o.ok ? o.data.map(x => ({ ...x, on: true })) : [];
      }
      if (list) nextOpts[key] = list.map(x => ({ ...x, on: !exc.map(String).includes(String(x.id)) }));
    }
    setModes(m); setOpts(nextOpts);
  };
  const saveNew = async (forUser) => {
    const j = await API('/all-report/saved/create/', { method: 'POST',
      body: JSON.stringify({ ...state(), title: cur.title, remark: cur.remark, for_user: forUser ? 1 : 0 }) });
    if (!j.ok) { showMsg(j.msg); return; }
    setCur(c => ({ ...c, id: j.id }));
  };
  const saveEdit = async () => {
    if (!cur.title.trim()) { showMsg('عنوان گزارش مشخص نشده است'); return; }
    if (!cur.id) { showMsg('گزارشی برای ویرایش انتخاب نشده است'); return; }
    const j = await API(`/all-report/saved/${cur.id}/`, { method: 'PUT', body: JSON.stringify({ ...state(), title: cur.title, remark: cur.remark }) });
    if (!j.ok) showMsg(j.msg);
  };
  const askDelete = () => {
    if (!cur.id) { showMsg('گزارشی برای حذف انتخاب نشده است'); return; }
    setAsk(true);
  };
  const doDelete = async () => {
    setAsk(null);
    const j = await API(`/all-report/saved/${cur.id}/`, { method: 'DELETE' });
    if (!j.ok) { showMsg(j.msg); return; }
    setCur({ id: 0, title: '', remark: '' });
  };

  const cols = res ? (res.columns || []).map(c => ({ key: c, label: c, num: !TEXT_COLS.includes(c) })) : [];
  const gridCols = res && res.report !== 1 ? [{ key: 'RepTitle', label: 'سرگروه', pre: true, wrap: true },
    { key: 'RunningTotalTitle', label: 'جمع جاری', pre: true, wrap: true }, ...cols] : cols;
  const shownCols = res ? gridCols.filter(c => (res.data || []).some(r => r[c.key] !== '' && r[c.key] != null)) : [];

  const toolbar = allowed && meta ? (
    <>
      <Box label="نوع گزارش" flex={0} minWidth="160px">
        <select value={report} onChange={e => { setReport(Number(e.target.value)); setRes(null); }} style={ui.input}>
          {meta.reports.map((t, i) => <option key={t} value={i}>{t}</option>)}
        </select>
      </Box>
      <Box label="تاریخ واگذاری: از" flex={0} minWidth="130px"><JalaliDatePicker value={range.from} onChange={v => setRange(r => ({ ...r, from: v }))} /></Box>
      <Box label="تا" flex={0} minWidth="130px"><JalaliDatePicker value={range.to} onChange={v => setRange(r => ({ ...r, to: v }))} /></Box>
      <button onClick={run} disabled={loading} style={ui.btnNew}>{loading ? '...' : 'آماده کردن گزارش'}</button>
      {res && res.data.length > 0 && report !== 2 && <button onClick={print} style={smallBtn}>گزارش</button>}
      {res && <ExcelButton title="گزارش کلی واگذاری کالا به اماکن" subtitle={`از ${range.from} تا ${range.to}`} columns={shownCols} rows={res.data} />}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', width: '100%' }}>
        {meta.dims.map(d => {
          const list = opts[d.key];
          const filtered = list && list.some(o => !o.on);
          return (
            <div key={d.key} style={{ display: 'flex', alignItems: 'center', gap: '4px', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '3px 6px', background: modes[d.key] ? '#eef3ff' : '#fff' }}>
              <button onClick={() => openOptions(d)} style={{ ...smallBtn, background: filtered ? '#6a1b9a' : smallBtn.background }}>{d.label}{filtered ? ' ✓' : ''}</button>
              <select value={modes[d.key] || ''} onChange={e => setModes(m => ({ ...m, [d.key]: e.target.value }))}
                style={{ fontSize: '11px', padding: '2px', borderRadius: '5px', border: '1px solid #ccc' }}>
                {MODES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
            </div>
          );
        })}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', width: '100%', alignItems: 'flex-end' }}>
        <Field label="عنوان گزارش" value={cur.title} onChange={v => setCur(c => ({ ...c, title: v }))} flex={2} />
        <Field label="شرح گزارش" value={cur.remark} onChange={v => setCur(c => ({ ...c, remark: v }))} flex={2} />
        <button onClick={openSaved} style={smallBtn}>گزارشات ذخیره شده</button>
        <button onClick={() => saveNew(false)} style={smallBtn}>ذخیره بعنوان گزارش جدید</button>
        <button onClick={() => saveNew(true)} style={smallBtn}>ذخیره بعنوان گزارش جدید برای کاربر جاری</button>
        <button onClick={saveEdit} style={smallBtn}>ذخیره تغییرات در گزارش فعلی</button>
        <button onClick={askDelete} style={{ ...smallBtn, background: '#c62828' }}>حذف گزارش</button>
      </div>
    </>
  ) : null;

  return (
    <>
      <ListPage user={user} onBack={onBack} title="گزارش کلی واگذاری کالا به اماکن" subtitle="تدارکات — سامانه ارجان" toolbar={toolbar}>
        {res && <Grid columns={shownCols} rows={res.data} rowKey="_id" empty="اطلاعاتی برای گزارش وجود ندارد" />}
      </ListPage>
      {openDim && <OptionsDialog dim={openDim} list={opts[openDim.key] || []}
        onChange={l => setOpts(o => ({ ...o, [openDim.key]: l }))} onClose={closeOptions} />}
      {saved && (
        <Modal title="گزارشات ذخیره شده" width="760px" onClose={() => setSaved(null)}>
          <Grid columns={[{ key: 'title', label: 'عنوان گزارش', wrap: true }, { key: 'remark', label: 'شرح', wrap: true }]}
            rows={saved} onDouble={loadSaved} />
        </Modal>
      )}
      {ask && <WarningDialog title="هشدار" lines={['آيا از حذف اين گزارش مطمئن هستيد؟']} confirmLabel="بلی" cancelLabel="خیر"
        tone="danger" onConfirm={doDelete} onCancel={() => setAsk(null)} />}
      {msg && <MessageBox lines={msg} onClose={() => setMsg(null)} />}
    </>
  );
}
